import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { useCardViewProvider } from 'components/CardViewProvider'

type StateProps = {
  isLoaded?: boolean,
}

const useCardDataProvider = (cardId: number) => {
  const selector = useMemo(() => createStructuredSelector<any, StateProps>({
    isLoaded: state => cardId && state['view-card'].view[cardId]?.isLoaded,
  }), [cardId])

  const {
    isLoaded,
  } = useSelector(selector)

  useCardViewProvider(cardId)

  return { isReady: cardId ? isLoaded : false }
}

export default useCardDataProvider